<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_info">
            <tt-input ttLabel="prodgrp2_id" [ttModel]="menu.prodgrp2_id" ttReadonly></tt-input>
            <tt-input ttLabel="prodgrp_name" [ttModel]="menu.prodgrp_name" ttReadonly></tt-input>
            <tt-input ttLabel="prodgrp3_id" [ttModel]="menu.prodgrp3_id" ttReadonly></tt-input>
            <tt-input ttLabel="prodgrp3_name" [ttModel]="menu.prodgrp3_name" ttReadonly></tt-input>
        </tt-card>

        <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
            <tt-button-goto [ttText]="'prodgrp3menu_edit'" [ttGoto]="'prodgrp3'" [ttGotoParms]="{ prodgrp2_id: menu.prodgrp2_id, prodgrp3_id: menu.prodgrp3_id }"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0 height-full">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp2_id" tt-model="vm.model.menu.prodgrp2_id" tt-change="vm.model.menu.prodgrp2_id = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp_name" tt-model="vm.model.menu.prodgrp_name" tt-change="vm.model.menu.prodgrp_name = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp3_id" tt-model="vm.model.menu.prodgrp3_id" tt-change="vm.model.menu.prodgrp3_id = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="prodgrp3_name" tt-model="vm.model.menu.prodgrp3_name" tt-change="vm.model.menu.prodgrp3_name = $value" tt-readonly="true"></tt-input>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="prodgrp3menu_edit" tt-goto="prodgrp3" tt-goto-parms="{ prodgrp2_id: vm.model.menu.prodgrp2_id, prodgrp3_id: vm.model.menu.prodgrp3_id }" tt-text-align="left"></tt-button-goto>
    </tt-card>

    <tt-grid ng-if="vm.model.gridReady" class="col-xs-12 p-5 flex-1" tt-options="vm.grid"></tt-grid>
</tt-page>-->
